import React from 'react' 
import './menu-item.style.scss'
import {withRouter} from 'react-router-dom';

import useWindowDimensions from '../../hooks/useWindowDimensions'

const MenuItem = ({title, imageUrl, size, history, linkUrl}) => {

  const { width } = useWindowDimensions();

  
  return (
    <div className={`${width > 800 ? (size): ('')} menu-item`} 
    onClick={() => history.push(`${linkUrl}`)} >

      <div className='background-image' style={{ 
        backgroundImage: `url(${imageUrl})`
      }}/> 

      <div className='content'>
        <h1 className='title'>{title.toUpperCase()}</h1>
        <span className='subtitle'>SHOP NOW</span>
      </div>
  </div>
)};

export default withRouter(MenuItem)